export const CUSTOMER_TYPES = ["Privatkund", "BRF", "Företag", "Offentlig", "Fastighetsägare", "Annat"];
export function validLeadEmail(value) {
  const email = String(value || "").trim();
  return email.length <= 254 && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}
export function validLeadPhone(value) {
  const phone = String(value || "").trim();
  const digits = phone.replace(/\D/g, "");
  return /^[+\d\s().-]+$/.test(phone) && digits.length >= 7 && digits.length <= 15;
}
export function validLeadContact(data) {
  return Boolean(String(data.name || "").trim() && validLeadEmail(data.email) && validLeadPhone(data.phone) && data.consent === true);
}
